<template>
  <div class="wrapper-navbar bg-main pb-4 flex-grow-1	">
    <b-row class="align-items-center text-white pt-2 pb-4 mx-lg-5 m-0">
      <div class="d-flex align-items-center">
        <i
          class="material-icons float-left cursor d-lg-none font-weight-bolder mr-3"
          @click="$router.go(-1)"
        >
          keyboard_arrow_left
        </i>
        <span class="title d-none d-md-block font-weight-bolder mx-0">
          {{ title }}
        </span>
        <span class="title d-md-none font-weight-bolder">
          {{ title }}
        </span>
      </div>
    </b-row>
  </div>
</template>

<script>
import NotificationsHeaderPopup from '@/notifications/components/NotificationsHeaderPopup.vue';

export default {
  components: {
    NotificationsHeaderPopup
  },
  props: {
    title: String,
    router: String
  }
};
</script>
<style lang="scss" scoped>
.title {
  letter-spacing: 0.7px;
}

</style>
